import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../stores/auth.store';

/**
 * Custel Ops route guard — sadece ADMIN role'üne sahip kullanıcılar görebilir.
 * Diğer roller `/` (Genel Bakış) sayfasına redirect edilir.
 *
 * Defense in depth: backend AbilitiesGuard zaten 403 dönüyor — bu component
 * frontend tarafında "kırık UI + console error spam" yerine net redirect sağlar.
 *
 * Kullanım:
 *   <Route path="/admin/x" element={<AdminOnly><Page /></AdminOnly>} />
 */
export function AdminOnly({ children }: { children: React.ReactNode }) {
  const role = useAuthStore((s) => s.user?.role ?? null);
  if (role !== 'OWNER') {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
}
